let _ = require("ES/lib/lodash");
let normalizeUsername = require("../../../../../utils/normalizeUsername");

// let getSpeakersOnEvent = function (event, Displaylists) {
//   return _.filter(Displaylists && Displaylists.perspeaker, function (spkr) {
//     return _.includes(event && event.sids, spkr.sid);
//   });
// };

module.exports = function (event) {
  let usernames = [];
  // We now return only active users
  _.forEach(_.get(event, "CoWorkers", []), function(a, speaker_id) {
    _.merge(usernames, _.pluck(_.filter(a, (b) => (
        _.get(b, ["active"], false)
    )), "id"));
  });

  if (_.has(event, "eventrep_login")) {
    usernames.push(event.eventrep_login);
  }
  usernames = _.uniq(_.filter(_.map(usernames, normalizeUsername), _.isString));
  usernames = _.sortBy(usernames);
  let r = _.object(_.map(usernames, function (username) {
    return [username, username];
  }));

  return r;
};



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/action_list/getUsernameOptions.js